module.exports = __webpack_public_path__ + "static/media/A18040103_10002_0.c320d9e5.jpg";